// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".community-container[data-v-6e1b3a90]{min-height:70vh;background:url(https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/landing/community_intro.png);background-size:90%;background-position:100% bottom;background-repeat:no-repeat}@media only screen and (max-width:640px){.community-container[data-v-6e1b3a90]{background-position:0 100%;background-size:200%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
